import axios from 'axios'
import { MapPin } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getProductsByVendeur } from '../../lib/apis'
import Loader from '../../components/loader'
import ProductCard from "../../components/productCard";
import StartRatings from '../../components/StartRatings'
import { useTranslation } from 'react-i18next'
import Breadcrumb from '../../components/Breadcrumb'
import { scrollToTop } from '../../lib/utils'

function Detail_Producteur() {
    const locations = useLocation()
    const [products, setProducts] = useState<any>()
    const { i18n } = useTranslation()
    const [loader, setLoader] = useState(true)
    const vendeur = locations.state

    useEffect(() => {
        scrollToTop()
    }, [])

    const updateProducts = async () => {
        try {
            const { data } = await axios.get(`${getProductsByVendeur}/${vendeur.user_id}/assets`)
            console.log("acteurs", data.products ? data.products : data.vehicles)
            // setProducts(data.products.lenght? data.products : data.vehicles)
            setProducts(data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoader(false)
        }
    }
    useEffect(() => {
        updateProducts()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    console.log("products", products)
    return (
        <div>
            <header className=' relative w-full h-[60vh] flex items-center bg-no-repeat bg-cover bg-center '
                style={{
                    backgroundImage: `url(${vendeur.profile_image_url ? vendeur.profile_image_url : "/assets/Vector.png"})`
                }}
            >
                <div className="absolute inset-0 bg-black/70"></div>

                <div className="relative items-center flex flex-row z-10 p-8">
                    <img className='w-[150px] h-[150px] rounded-full border-2' src={vendeur.profile_image_url ? vendeur.profile_image_url : "/assets/Vector.png"} alt="" />
                    <div className='ml-5'>
                        <div className='flex flex-row items-center'>
                            <div className='bg-[#15803D] text-[15px] text-white font-[400] px-2 py-1 rounded-sm'>
                                {vendeur.acteur_name}
                            </div>
                            <div className='text-white text-[13px] flex flex-row ml-9 items-center'>
                                {/* <Star size={20} color='#FACC15' /> */}
                                <StartRatings rating={vendeur.average_note} />
                                {/* {vendeur.average_note} */}
                            </div>
                        </div>
                        <div className=' font-bold text-[32px]  text-white font-sans mt-3 ' >
                            {vendeur.name}
                        </div>
                        <div className='flex text-white items-center mt-5'>
                            <MapPin size={20} />
                            <div className=' ml-2'>
                                {vendeur.region} {vendeur.departement}  | {vendeur.address}
                            </div>

                        </div>
                    </div>
                </div>
            </header>
            <div className="flex flex-row py-5 items-center justify-start w-full ">

                <Breadcrumb />
            </div>
            <section className='w-full bg-opacity-10 flex flex-col items-center px-2 py-8 justify-center'>
                {
                    loader ? <Loader /> :
                        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-20'>
                            {
                                products?.products.length > 0 &&
                                products.products.map((product: any) => {
                                    return (
                                        <ProductCard
                                            key={product.product_id ? product.product_id : product.vehicle_id}
                                            category_name={product.category_name}
                                            image={JSON.parse(product.images)[0]}
                                            sub_category_name={product.sub_category_name}
                                            title={i18n.language === "fr" ? product.product_name : product.product_name_en}
                                            quality={product.minimum_quantity}
                                            price={product.price}
                                            quantity={product.Stocks.quantity}
                                            uml={product.type}
                                            stock={product.Stocks.quantity}
                                            productId={product.product_id}
                                            seller={product.producer_name}
                                        />
                                    )
                                })
                            }
                            {
                                products?.vehicles.length > 0
                                &&
                                products.vehicles.map((product: any) => {
                                    return (
                                        <div className='w-full md:w-[290px] bg-grey-100 shadow-xl rounded-lg overflow-hidden mx-auto ' key={product.vehicle_id} >
                                            <img className='w-[100%] h-[200px] ' src={JSON.parse(product.images)[0]} alt="vehicule" />
                                            <div className=' m-5 font-[700] ' >{product.name}</div>
                                            <div className=' m-5 font-[700] ' >{product.model}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>

                }
            </section>
        </div>
    )
}

export default Detail_Producteur